/* @flow */

import React from 'react';
import LinkView from 'lib/ui/link-view';
import Styled from 'styled';
import { observer } from 'mobx-react';

import EmphasizedTextView from 'four-nets/ui/emphasized-text-view';
import BoxView from 'four-nets/ui/box-view';
import Localizable from 'lib/intl/localizable';
import FormattedDateAgoView from 'lib/intl/formatted-date-ago-view';

import striptags from 'striptags';
import defaultStyles from './post-item-view.scss';

import emphasizedStyles from './emphasized-text-view.scss';

@Localizable()
@observer
@Styled(defaultStyles)
class PostItemView extends React.Component {
    render() {
        const {
            title,
            tag,
            img,
            link,
            categoryLinks,
            emphasized,
            emphasize,
            styles,
            text,
            badges,
            linkText,
            postDate,
        } = this.props;

        const content = emphasized ? (
            <div
                className={styles.emphasized}
                dangerouslySetInnerHTML={{
                    __html: striptags(text, ['em']),
                }}
            />
        ) : (
            <EmphasizedTextView text={text} emphasize={emphasize} styles={emphasizedStyles} />
        );

        return (
            <div className={styles.postItem}>
                {img ? (
                    <LinkView key='image' className={styles.image} link={link}>
                        {img}
                    </LinkView>
                ) : null}
                <div
                    key='content'
                    style={{
                        width: '100%',
                    }}
                >
                    <LinkView link={link} className={styles.link}>
                        {emphasized ? (
                            <span
                                className={styles.emphasized}
                                dangerouslySetInnerHTML={{
                                    __html: striptags(title, ['em']),
                                }}
                            />
                        ) : (
                            <EmphasizedTextView text={title} emphasize={emphasize} styles={emphasizedStyles} />
                        )}
                    </LinkView>
                    <ul className={styles.list}>
                        {tag ? (
                            <li key='-1' className={styles.item}>
                                <div key='box' className={styles.box}>
                                    <BoxView mini={true}>
                                        <span className={styles.tag}>{tag}</span>
                                    </BoxView>
                                </div>
                            </li>
                        ) : null}
                        {categoryLinks.map((categoryLink, index) => (
                            <li key={index} className={styles.item}>
                                <LinkView key={categoryLink.label} link={categoryLink} className={styles.categoryLink}>
                                    {categoryLink.category.name}
                                    {index !== categoryLinks.length - 1 ? <div className={styles.delimiter} /> : null}
                                </LinkView>
                            </li>
                        ))}
                        <li className={styles.item} key={categoryLinks.length} className={styles.date}>
                            <FormattedDateAgoView value={postDate} />
                        </li>
                    </ul>
                    <div className={styles.content}>
                        {linkText ? (
                            <LinkView link={link} className={styles.textLink}>
                                {content}
                            </LinkView>
                        ) : (
                            content
                        )}
                    </div>
                    {badges ? (
                        <div className={styles.badges}>
                            {badges.map((badge, index) => (
                                <div key={index} className={styles.badge}>
                                    {badge}
                                </div>
                            ))}
                        </div>
                    ) : null}
                </div>
            </div>
        );
    }
}

export default PostItemView;
